/* eslint-disable import/prefer-default-export */
import { useCallback, useEffect, useState } from 'react';

import { POSITION_KEY } from '../utils/consts';
import { getLinesByPosition } from '../../../services/adminContracts';
import { tryCatchMaker } from '../../../utils/globalFunctions';
import useToast from '../../../hooks/useToast';

export const usePositionLineForm = ({ filters, currentContractsSelected }) => {
  const { setNewToast } = useToast();
  const [{ position, line, positionLine }, setPositionLine] = useState({
    position: '',
    line: '',
    positionLine: filters.posicionesLineas ?? []
  });
  const [linesOptions, setLinesOptions] = useState([]);

  useEffect(() => {
    setPositionLine((prevState) => ({
      ...prevState,
      positionLine: filters.posicionesLineas ?? []
    }));
  }, [filters]);

  const handlePositionLineChange = useCallback(
    (key, newValue) => {
      if (POSITION_KEY === key) {
        if (newValue) {
          tryCatchMaker({
            promise: () => getLinesByPosition(currentContractsSelected, newValue.nombre),
            defaultValue: [],
            setNewToast
          }).then((data) => {
            setLinesOptions(data);
          });
        }

        return setPositionLine((prevState) => ({
          ...prevState,
          line: '',
          [key]: newValue
        }));
      }

      return setPositionLine((prevState) => ({
        ...prevState,
        [key]: newValue
      }));
    },
    [currentContractsSelected, setNewToast]
  );

  const resetPositionLineChips = useCallback(() => {
    setPositionLine((prevState) => ({
      ...prevState,
      positionLine: []
    }));
  }, []);

  const resetPositionAndLineFields = useCallback(() => {
    setPositionLine((prevState) => ({
      position: '',
      line: '',
      positionLine: [...prevState.positionLine]
    }));
  }, []);

  const addPositionLine = useCallback(() => {
    // *This label is for UI requirement
    const positionLineLabel = `P${position.nombre} - L${line.nombre}`;

    setPositionLine((prevState) => ({
      position: '',
      line: '',
      positionLine: [
        ...prevState.positionLine,
        {
          label: positionLineLabel,
          value: `${position.nombre}-${line.nombre}`
        }
      ]
    }));
  }, [position, line]);

  const deletePositionLine = useCallback(({ label }) => {
    setPositionLine((prevState) => ({
      ...prevState,
      positionLine: prevState.positionLine.filter((e) => e.label !== label)
    }));
  }, []);

  return {
    handlePositionLineChange,
    resetPositionAndLineFields,
    addPositionLine,
    deletePositionLine,
    resetPositionLineChips,
    positionLine,
    linesOptions,
    position,
    line
  };
};
